import { render } from "./CustomerInsightsPage.vue?vue&type=template&id=7bce6faa&scoped=true"
import script from "./CustomerInsightsPage.vue?vue&type=script&lang=js"
export * from "./CustomerInsightsPage.vue?vue&type=script&lang=js"

import "./CustomerInsightsPage.vue?vue&type=style&index=0&id=7bce6faa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bce6faa"]])

export default __exports__